/**
 * ScrollToTopOnPathnameUpdate
 */
import * as React from 'react';
import { withRouter } from 'react-router';

interface Props {
    location: {
        pathname: string
    };
    children: React.Node;
}

export class ScrollToTopOnPathnameUpdate extends React.PureComponent<Props> {
    componentDidUpdate(prevProps: Props) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            global.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTopOnPathnameUpdate);
